import * as React from 'react'
import { useLocale } from '../../providers'
import { Form, Input } from '../Forms'
import { Button } from '../Buttons'

interface RecorderFormProps {
  handleSubmit: (values: RecorderFormValues) => void
}

const initialValues = {
  name: '',
  location: '',
}

export interface RecorderFormValues {
  name: string
  location: string
}

const validateMaxLength = (maxLength: number) => (value: string) => {
  if (value.length < maxLength) return true
  return `Must be less than ${maxLength} characters`
}

export const RecorderForm: React.FC<RecorderFormProps> = ({ handleSubmit }) => {
  const { getText } = useLocale()
  return (
    <Form<RecorderFormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
    >
      <Input
        name="name"
        type="input"
        label={getText('nameFieldLabel')}
        validate={validateMaxLength(75)}
      />
      <Input
        name="location"
        type="input"
        label={getText('locationFieldLabel')}
        validate={validateMaxLength(100)}
      />
      <Button type="submit" label={getText('startRecordingCta')} />
    </Form>
  )
}